import React from 'react';
interface CardProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
  footer?: React.ReactNode;
}
const Card: React.FC<CardProps> = ({
  title,
  children,
  className = '',
  footer
}) => {
  return <div className={`bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 ${className}`} data-id="element-218">
      {title && <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-700" data-id="element-219">
          <h3 className="font-medium" data-id="element-220">{title}</h3>
        </div>}
      <div className="p-4" data-id="element-221">{children}</div>
      {footer && <div className="px-4 py-3 border-t border-gray-200 dark:border-gray-700" data-id="element-222">
          {footer}
        </div>}
    </div>;
};
export default Card;